import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { UsersGateway } from '@domain/gateway/users-gateway';
import { UserModel, UserServerModel } from '@domain/entities/user.model';
import { GeneralResult } from '@domain/entities/general';

@Injectable({
    providedIn: 'root',
})
export class UserService extends UsersGateway {
    private endpoint = 'v1/users';

    constructor(private _http: HttpClient) {
        super();
    }

    /**
     * @description Get users
     * @param params (Optional)
     * @returns Observable of users entity
     */
    read(params?: HttpParams): Observable<GeneralResult<UserServerModel>> {
        return this._http.get<GeneralResult<UserServerModel>>(
            `${environment.host}${this.endpoint}`,
            {
                params,
            }
        );
    }

    /**
     * @description Create users
     * @returns Observable of users entity
     */
    create(form: UserModel): Observable<UserServerModel> {
        return this._http.post<UserServerModel>(
            `${environment.host}${this.endpoint}`,
            form
        );
    }

    /**
     * @description Read a users
     * @returns Observable of users entity description
     */
    readById(id: number): Observable<UserServerModel> {
        return this._http.get<UserServerModel>(
            `${environment.host}${this.endpoint}/${id}`
        );
    }

    /**
     * @description Update users
     * @returns Observable of users entity
     */
    update(id: number, form: UserModel): Observable<UserServerModel> {
        return this._http.put<UserServerModel>(
            `${environment.host}${this.endpoint}/${id}`,
            form
        );
    }

    /**
     * @description Delete users
     * @returns Observable of users entity
     */
    delete(id: number): Observable<UserServerModel> {
        return this._http.delete<UserServerModel>(
            `${environment.host}${this.endpoint}/${id}?force=true`
        );
    }
}
